import { Box, type BoxProps } from '@chakra-ui/react';

export interface MessageTextProps extends BoxProps {}

export function MessageText(props: MessageTextProps) {
  return (
    <Box
      className="MessageText"
      color="fg"
      whiteSpace="pre-wrap"
      wordBreak="break-all"
      fontWeight="medium"
      {...props}
    />
  );
}
